import { Action, Dispatch } from 'redux'
import { closeModalAction } from 'reducks/modal/actions'
import { initBasketsAction } from 'reducks/basket/actions'
import { initBrandAction } from 'reducks/brand/actions'
import { initBreadsAction } from 'reducks/bread/actions'
import { initCalendarAction } from 'reducks/calendar/actions'
import { initCheckoutAction } from 'reducks/checkout/actions'
import { initConfirmAction } from 'reducks/confirm/actions'
import { initManufacturersAction } from 'reducks/manufacturer/actions'
import { initPointCardAction } from 'reducks/pointCard/actions'
import { initSchedulesAction } from 'reducks/schedule/actions'
import { initShopAction } from 'reducks/shop/actions'
import { initShopSubscriptionsAction } from 'reducks/shopSubscription/actions'
import { initStaffsAction } from 'reducks/staff/actions'
import { initStocksAction } from 'reducks/stock/actions'
import { initStoreAction } from 'reducks/store/actions'
import { initStoreCalendarAction } from 'reducks/storeCalendar/actions'
import { initStoreDeliveryBreadAction } from 'reducks/storeDeliveryBread/actions'
import { initStoreShippingsAction } from 'reducks/storeShipping/actions'
import { initStoreTimesaleAction } from 'reducks/storeTimesale/actions'
import { initUsersAction } from 'reducks/user/actions'

const initRootState = (dispatch: Dispatch<Action>) => {
  dispatch(closeModalAction())
  dispatch(initBasketsAction())
  dispatch(initBrandAction())
  dispatch(initBreadsAction())
  dispatch(initCalendarAction())
  dispatch(initCheckoutAction())
  dispatch(initConfirmAction())
  dispatch(initManufacturersAction())
  dispatch(initPointCardAction())
  dispatch(initSchedulesAction())
  dispatch(initShopAction())
  dispatch(initShopSubscriptionsAction())
  dispatch(initStaffsAction())
  dispatch(initStocksAction())
  dispatch(initStoreAction())
  dispatch(initStoreCalendarAction())
  dispatch(initStoreDeliveryBreadAction())
  dispatch(initStoreShippingsAction())
  dispatch(initStoreTimesaleAction())
  dispatch(initUsersAction())
}

export default initRootState
